import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'antd';
import cn from 'classnames';
import classes from './Card.module.scss';

const SimpleCard = (props) => {
  const { title, description, className, bordered, actions = [] } = props;

  const renderActions = () => {
    if (!actions || actions.length === 0) return null;
    return (
      <div className={classes.actions}>
        {actions.map((action, index) => {
          if (action.asSlot) {
            const Slot = action.asSlot;
            return <Slot key={index} {...action} />;
          }
          return <Button key={index} className={classes.actionButton} {...action} />;
        })}
      </div>
    );
  };

  return (
    <Card className={cn(classes.simple, className)} bordered={bordered}>
      <div className={classes.wrapper}>
        <Card.Meta title={title} description={description} />
        {renderActions()}
      </div>
    </Card>
  );
};

SimpleCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  actions: PropTypes.array,
  loading: PropTypes.bool,
  className: PropTypes.string,
};
SimpleCard.defaultProps = {
  title: 'Default Title',
  description: null,
  actions: [],
  loading: false,
  className: '',
};

export default SimpleCard;
